<template>
  <div>
    <div class="m-subheader ">
      <div class="d-flex align-items-center">
        <div class="mr-auto">
          <ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
		  	  	<li class="m-nav__item">
		  	  		<router-link :to="{name: 'home'}">
		  	  			<span class="m-nav__link-text">
                  <i class="m-nav__link-icon la la-home"></i>
		  	  			</span>
		  	  		</router-link>
		  	  	</li>
		  	  	<li class="m-nav__separator">
		  	  		>
		  	  	</li>
		  	  	<li class="m-nav__item">
		  	  		<span class="m-nav__link-text">
		  	  			{{'search_for_visitors' | translate | titleize}}
		  	  		</span>
		  	  	</li>
		  	  </ul>
        </div>
      </div>
    </div>
    <div class="m-content">
      <!-- AQUI INICIA LA SECCION DE BUSQUEDA INICIAL -->
      <div class="m-portlet m-portlet--tab">
        <div class="m-portlet__head">
          <div class="m-portlet__head-caption">
            <div class="m-portlet__head-title">
              <span class="m-portlet__head-icon m--hide">
                <i class="la la-gear"></i>
              </span>
              <h3 class="m-portlet__head-text">
                {{'search_for_visitors' | translate | titleize}}
              </h3>
            </div>
          </div>
        </div>
        <form data-vv-scope="searh_form" class="m-form m-form--state">
          <div class="m-portlet__body">
            <div class="form-group m-form__group row">
              <div class="col-lg-4 pb-3">
                <label>{{'select_search_type' | translate | capitalize}}</label>
                <select id="select_search_type" v-model="search_type"  class="form-control m-bootstrap-select m_selectpicker">
                  <option :value="option.value" v-for="(option, idx) in search_options" :key="idx">{{ option.name | translate | capitalize }}</option>
                </select>
                {{refreshSelector(`select_search_type`)}}
              </div>
              <div v-if="search_type === 3" :class="[{'has-danger': errors.has(`searh_form.select_credential_type`)}, 'col-lg-3']">
                <label>{{ 'select_credential' | capitalize }}</label>
                <select id="select_credential_type" v-model="credential_type" data-vv-as="select_credential_type" name="select_credential_type" v-validate="'required'"  class="form-control m-bootstrap-select m_selectpicker">
                  <option value="">{{'select_an_option' | capitalize}}</option>
                  <option :value="credential.id" v-for="(credential, idx) in credential_list" :key="idx">{{ credential.description | translate | capitalize }}</option>
                </select>
                {{refreshSelector(`select_credential_type`)}}
                <span v-show="errors.has(`searh_form.select_credential_type`)" class="m-form__help m--font-danger"> {{errors.first(`searh_form.select_credential_type`)}} </span>
              </div>
              <div :class="[{'has-danger': errors.has(`searh_form.enter_value`)}, search_type === 3 ? 'col-lg-3' : 'col-lg-6']">
                <label for="enter_value">{{'enter_value' | translate | capitalize}}</label>
                <input :data-vv-as="'enter_value' | translate" type="text" v-model="search_value" :name="`enter_value`" class="form-control m-input" ref="id_num" v-validate="search_type == 0 ? 'required|alpha_num|min:3' : search_type == 1 ? { required: true, min:3, regex:/^[A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜÑ\s]*$/i } : 'required'" autofocus>
                <span v-show="errors.has(`searh_form.enter_value`)" class="m-form__help m--font-danger"> {{errors.first(`searh_form.enter_value`)}} </span>
              </div>
              <div v-show="search_type === 3" :class="[{'has-danger': errors.has(`searh_form.facility_code`)}, 'col-lg-2']">
                <label for="facility_code">{{'facility_code' | translate | capitalize}}</label>
                <input :data-vv-as="'facility_code' | translate" type="text" v-model="search_value_facility" :name="`facility_code`" class="form-control m-input" ref="facility_code" v-validate="'alpha_num'" autofocus>
                <span v-show="errors.has(`searh_form.facility_code`)" class="m-form__help m--font-danger"> {{errors.first(`searh_form.facility_code`)}} </span>
              </div>
              <div class="col-lg-2">
                <label>&nbsp;</label><br>
                <button v-on:keyup.tab="disable()" @click.prevent="searchPerson" class="btn btn-primary">
                  {{'search' | translate | capitalize}}
                </button>
                <a href="" class="btn btn-danger" @click.prevent="cancelSearch()">
                  <i class="la la-trash"></i>
                </a>
              </div>
            </div>
            <!-- Datatable de busqueda -->
            <div v-show="!singular" class="m-portlet m-portlet--tab">
              <s-datatable v-show="data_search.length > 0 && show_datatable || show_datatable && !validPermission(4407)" :config="datatable" @data="data_search = $event" @final_query="show_datatable = $event">
                <div slot="actions" slot-scope="props">
                  <a v-tooltip="messageDetailTooltip" v-if="props.row.authorizations_reception.length > 0" class="m-portlet__nav-link btn m-btn m-btn--icon m-btn--icon-only m-btn--pill btn_edit" @click="showPerson(props.row.id, props.row.person_novelty)">
                    <i class="la la-eye"></i>
                  </a>
                  <span v-else-if="validateBlockade(today, props.row.person_novelty)" class="badge badge-pill badge-danger">
                    {{'person_blocked' | translate | capitalize}}
                  </span>
                  <button v-else class="btn btn-brand btn-sm m-btn m-btn--pill m-btn--wide" @click.prevent="goToAuthorization()">
                    {{'authorize' | translate | capitalize}}
                  </button>
                </div>
              </s-datatable>
            </div>
            <div v-show="(data_search.length === 0 || create_autho)  && show_datatable && validPermission(4407)" class="m-alert m-alert--icon m-alert--outline alert alert-primary" role="alert">
              <div class="m-alert__icon">
                <i class="la la-warning"></i>
              </div>
              <div class="m-alert__text"> {{'authorization_not_found' | translate | capitalize}},
                <strong v-show="search_type === 0">{{'authorization_question' | translate | capitalize}}</strong>
              </div>
              <div v-show="search_type === 0 && !person_blocked" class="m-alert__actions" style="width: 200px;">
                <button type="button" class="btn btn-brand btn-sm m-btn m-btn--pill m-btn--wide" @click="goToAuthorization()" :disabled="!allow_create_authorizations">
                  {{'authorize' | translate | capitalize}}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
      <!-- AQUI FINALIZA LA SECCION DE BUSQUEDA INICIAL -->

      <div v-if="searched && singular && belongs_to_company" class="m-portlet m-portlet--tab">
        <div class="m-portlet__head">
          <div class="m-portlet__head-caption">
            <div class="m-portlet__head-title">
              <span class="m-portlet__head-icon m--hide">
                <i class="la la-gear"></i>
              </span>
              <h3 class="m-portlet__head-text" ref='info_div'>
                {{'general_info' | translate | titleize}}
              </h3>
            </div>
          </div>
        </div>
        <div class="m-portlet__body break-world">
          <div v-if="!hide_person_data" class="form-group m-form__group row">
            <div class="col-lg-2 pb-2" v-if="is_photo_auth === 'true'">
              <figure class="figure">
                <img class="img-thumbnail img-web-w min-150" :src="person_info.image">
              </figure>
            </div>
            <div :class="is_photo_auth === 'true' ? 'col-lg-10 pb-3' : 'col-lg-12 pb-3'">
              <div v-if="!hide_person_data" class="form-group m-form__group row">
                <div :class="is_photo_auth === 'true' ? 'col-lg-4 pb-3' : 'col-lg-3 pb-3'">
                  <label>{{'identification_number' | translate | capitalize}}</label>
                  <input  type="text" class="form-control m-input" :value="`${person_info.identification_types.abbreviation} ${person_info.identification_number}`" readonly>
                </div>
                <div :class="is_photo_auth === 'true' ? 'col-lg-4 pb-3' : 'col-lg-3 pb-3'">
                  <label>{{'first_names' | translate | capitalize}}</label>
                  <input type="text" class="form-control m-input" v-model="person_info.first_name" readonly>
                </div>
                <div :class="is_photo_auth === 'true' ? 'col-lg-4 pb-3' : 'col-lg-3 pb-3'">
                  <label>{{'last_names' | translate | capitalize}}</label>
                  <input  type="text" class="form-control m-input" v-model="person_info.last_name" readonly>
                </div>
                <div :class="is_photo_auth === 'true' ? 'col-lg-4 pb-3' : 'col-lg-3 pb-3'">
                  <label>{{'email' | translate | capitalize}}</label>
                  <input  type="text" class="form-control m-input" v-model="person_info.email" readonly>
                </div><br><br>
              </div>
            </div>

            <div v-if="searched && move_record == 'true' && validPermission(1407)" class="col-lg-12 center-text">
              <button @click.prevent="recMovement()" class="btn btn-primary" ref="move_button">
                {{text_button | translate | capitalize}}
              </button>
            </div>
            <br><br>

          </div>
          <div id="authorizations_accordion">
            <div class="card" v-for="(authorization, index) in person_info.authorizations_reception" :key="index" v-if="validCompany(authorization.company.id)">
              <div class="card-header cursor-pointer" data-parent="#authorizations_accordion" :id="`heading_${index}`" data-toggle="collapse" :data-target="`#expiration_documents_${index}`" :aria-expanded="person_info.authorizations_reception.length==1 ? true : false" :aria-controls="`expiration_documents_${index}`">
                <p class="mb-0 card_title">
                  {{ 'authorization_as' | translate | capitalize }} <b>{{ authorization.access_profile.authorized_type.name.toUpperCase() }}</b> {{ 'for_company' | translate }} <b>{{ authorization.company.name.toUpperCase() }}</b>
                </p>
              </div>
              <div :id="`expiration_documents_${index}`" class="collapse" :class="{'show': person_info.authorizations_reception.length==1 || current_company_type !== admin_company}" :aria-labelledby="`heading_${index}`">
                <div class="card-body">

                  <div v-if="preautorization === 2" class="m-alert m-alert--icon m-alert--outline alert alert-warning" role="alert">
                    <div class="m-alert__icon">
                      <i class="la la-warning"></i>
                    </div>
                    <div class="m-alert__text">
                      <b>{{ 'pending_pre_authorization' | capitalize }}</b>
                    </div>
                  </div>

                  <div v-if="preautorization === 3" class="m-alert m-alert--icon m-alert--outline alert alert-danger" role="alert">
                    <div class="m-alert__icon">
                      <i class="la la-warning"></i>
                    </div>
                    <div class="m-alert__text">
                      <b>{{ 'refused_pre_authorization' | capitalize }}</b>
                    </div>
                  </div>

                  <div v-bind:key="refreshCount" v-if="(validate_training[index] > 0) && validate_covid && (prop_training === 'true')" class="m-alert m-alert--icon m-alert--outline alert alert-danger" role="alert">
                    {{change_active_autho_status(index)}}
                    <div class="m-alert__icon">
                      <i class="la la-certificate"></i>
                    </div>
                    <div class="m-alert__text">
                      <b>{{ 'training_missing' | capitalize }}</b><br>
                    </div>
                  </div>

                  <div v-bind:key="refreshCount" v-if="(validate_training[index] > 0) && validate_covid && (prop_training === 'false')" class="m-alert m-alert--icon m-alert--outline alert alert-warning" role="alert">
                    {{change_active_autho_status(index)}}
                    <div class="m-alert__icon">
                      <i class="la la-certificate"></i>
                    </div>
                    <div class="m-alert__text">
                      <b>{{ 'pending_training' | capitalize }}</b><br>
                    </div>
                  </div>

                  <div v-if="hourToSeconds(time_property) < hourToSeconds(authorization.access_profile.start_time) || hourToSeconds(time_property) > hourToSeconds(authorization.access_profile.end_time)" class="m-alert m-alert--icon m-alert--outline alert alert-warning" role="alert">
                    {{change_active_autho_status(index)}}
                    <div class="m-alert__icon">
                      <i class="la la-warning"></i>
                    </div>
                    <div class="m-alert__text"> {{'authorization_out_of_time' | translate | capitalize}}
                    </div>
                  </div>
                  <div v-if="documents_validated.length > 0" v-for="(document_valid, item) in documents_validated" :key="item" class="m-alert m-alert--icon m-alert--outline alert alert-danger" role="alert">
                    {{change_active_autho_status(index)}}
                    <div class="m-alert__icon">
                      <i class="la la-warning"></i>
                    </div>
                    <div class="m-alert__text">
                      <b>{{ 'expired_document' | capitalize }}</b><br>
                      <b>{{ `${document_valid.name}: ${document_valid.value}` }}</b>
                    </div>
                  </div>
                  <div v-if="validate_access_day[index]" class="m-alert m-alert--icon m-alert--outline alert alert-danger" role="alert">
                    {{change_active_autho_status(index)}}
                    <div class="m-alert__icon">
                      <i class="la la-warning"></i>
                    </div>
                    <div class="m-alert__text">
                      {{ 'cannot_access_today' | capitalize }} {{ day_name | translate }}
                    </div>
                  </div>
                  <div v-if="validate_end_date[index]" class="m-alert m-alert--icon m-alert--outline alert alert-danger" role="alert">
                    {{change_active_autho_status(index)}}
                    <div class="m-alert__icon">
                      <i class="la la-warning"></i>
                    </div>
                    <div class="m-alert__text">
                      {{ 'expired_authorization' | capitalize }}
                    </div>
                  </div>
                  <div v-if="validate_start_date[index]" class="m-alert m-alert--icon m-alert--outline alert alert-danger" role="alert">
                    {{change_active_autho_status(index)}}
                    <div class="m-alert__icon">
                      <i class="la la-warning"></i>
                    </div>
                    <div class="m-alert__text">
                      <b>{{ 'cannot_access_today' | capitalize }}</b>
                    </div>
                  </div>
                  <div v-if="validate_blockade[index]" class="m-alert m-alert--icon m-alert--outline alert alert-danger" role="alert">
                    {{change_active_autho_status(index)}}
                    <div class="m-alert__icon">
                      <i class="la la-times-circle"></i>
                    </div>
                    <div class="m-alert__text">
                      {{ 'person_currently_has' | capitalize }} <b>{{ blockade_type[index] | capitalize }}</b><br>
                      {{ 'contact_property_management' | capitalize }}
                    </div>
                  </div>

                  <div v-bind:key="refreshCount" v-if="validate_preauthorization === true &&  active_autho[index] && (validate_training[index] === 0)" class="m-alert m-alert--icon m-alert--outline alert alert-success" role="alert">
                    <div class="m-alert__icon">
                      <i class="la la-check"></i>
                    </div>
                    <div class="m-alert__text">
                      <b>{{ 'active_authorization' | capitalize }}</b>
                    </div>
                  </div>

                   <div v-if="validate_novelty[index] && !validate_blockade[index]" :class="(novelty_type[index].is_access === 1) ? 'm-alert m-alert--icon m-alert--outline alert alert-info' : 'm-alert m-alert--icon m-alert--outline alert alert-danger'" role="alert">
                    {{change_active_autho_status(index)}}
                    <div class="m-alert__icon">
                      <i class="la la-clipboard"></i>
                    </div>
                    <div class="m-alert__text">
                      {{ 'autho_has_novelty' | capitalize }}<br>
                      <b>{{ novelty_type[index].name | capitalize }}</b>
                    </div>
                  </div>

                  <div class="form-group m-form__group row">
                    <div class="col-lg-12 pb-3">
                      <label><b>{{'access_data' | translate | capitalize}}</b></label>
                    </div>
                    <div class="col-lg-3 pb-3">
                      <label>{{'start_date' | translate | capitalize}}</label>
                      <input  type="text" class="form-control m-input" v-model="authorization.start_date" readonly>
                    </div>
                    <div class="col-lg-3 pb-3">
                      <label>{{'end_date' | translate | capitalize}}</label>
                      <input v-if="authorization.end_date !== ''" type="text" class="form-control m-input" v-model="authorization.end_date" readonly>
                      <input v-else type="text" class="form-control m-input" :value="'undefined_date' | translate | capitalize" readonly>
                    </div>
                    <div class="col-lg-3 pb-3">
                      <label>{{'start_time' | translate | capitalize}}</label>
                      <input  type="text" class="form-control m-input" v-model="authorization.access_profile.start_time" readonly>
                    </div>
                    <div class="col-lg-3 pb-3">
                      <label>{{'end_time' | translate | capitalize}}</label>
                      <input type="text" class="form-control m-input" v-model="authorization.access_profile.end_time" readonly>
                    </div>
                    <div class="col-lg-3 pb-2">
                      <label>{{'access_profile' | translate | capitalize}}</label>
                      <input type="text" class="form-control m-input" v-model="authorization.access_profile.name" readonly>
                    </div>
                    <div class="col-lg-3 pb-2">
                      <label>{{'income_number' | translate | capitalize}}</label>
                      <input type="text" class="form-control m-input" v-model="authorization.access_profile.income_number" readonly>
                    </div>
                    <div class="col-lg-3 pb-2">
                      <label>{{'access_days' | translate | capitalize}}</label>
                      <textarea type="text" class="form-control m-input" style="margin-top: 0px; margin-bottom: 0px; height: 65px;" :value="autho_access_days[index].trim()" readonly></textarea>
                    </div>
                    <div class="col-lg-3 pb-2">
                      <label>{{'authorized_control_points' | translate | capitalize}}</label>
                      <textarea type="text" class="form-control m-input" style="margin-top: 0px; margin-bottom: 0px; height: 65px;" :value="autho_control_points[index].trim()" readonly></textarea>
                    </div>
                  </div>

                  <div class="form-group m-form__group row">
                    <div class="col-lg-3 pb-2">
                      <label>{{'user_register' | translate | capitalize}}</label>
                      <input  type="text" class="form-control m-input" v-if="authorization.created === null" readonly>
                      <input  type="text" class="form-control m-input" v-else v-model="authorization.created.full_name" readonly>
                    </div>
                    <div class="col-lg-3 pb-2">
                      <label>{{'date_register' | translate | capitalize}}</label>
                      <input  type="text" class="form-control m-input" v-if="authorization.created === null" readonly>
                      <input type="text" class="form-control m-input"  v-else v-model="authorization.create_time" readonly>
                    </div>
                    <div class="col-lg-3 pb-2">
                      <label>{{'user_updated' | translate | capitalize}}</label>
                      <input  type="text" class="form-control m-input" v-if="authorization.updated === null" readonly>
                      <input  type="text" class="form-control m-input" v-else v-model="authorization.updated.full_name" readonly>
                    </div>
                    <div class="col-lg-3 pb-2">
                      <label>{{'date_updated' | translate | capitalize}}</label>
                      <input  type="text" class="form-control m-input" v-if="authorization.updated === null" readonly>
                      <input  type="text" class="form-control m-input"  v-else v-model="authorization.update_time" readonly>
                    </div>
                  </div>
                  <div class="form-group m-form__group row">
                    <div class="col-lg-6 pb-2">
                      <label>{{'observations' | translate | capitalize}}</label>
                      <textarea style="margin-top: 0px; margin-bottom: 0px; height: 48px;" type="text" class="form-control m-input" v-model="authorization.observations" readonly></textarea>
                    </div>
                    <div v-show="authorization.own_fleet" class="col-lg-6 pb-2 m-checkbox-list m-checkbox-inline-form-wizard" style="margin-top: 40px;">
                      <label class="m-checkbox">
                        <input type="checkbox" v-model="authorization.own_fleet" disabled>
                        {{ 'is_own_fleet' | translate | capitalize }}
                        <span></span>
                      </label>
                    </div>
                  </div>
                  <div class="col-lg-3 pb-5">
                    <a v-if="authorization.person_vehicles.length > 0" href="" class="buttons-actions btn btn-primary m-btn m-btn--icon btn-lg m-btn--icon-only m-btn--pill" data-toggle="modal" data-backdrop="static" data-keyboard="false" data-target="#add_cars_modal" @click="showModals(index)">
                      <i class="fa fa-car"></i>
                      <span class="badge badge-notification">{{authorization.person_vehicles.length}}</span>
                    </a>
                    <label v-if="authorization.person_vehicles.length > 0">&nbsp;</label>
                    <a v-if="authorization.person_vehicles.length > 0" href="" class="buttons-actions btn btn-primary m-btn m-btn--icon btn-lg m-btn--icon-only m-btn--pill" data-toggle="modal" data-backdrop="static" data-keyboard="false" data-target="#add_ownfleet_cars_modal" @click="showModals(index)">
                      <i class="fa fa-bus"></i>
                      <span class="badge badge-notification">{{authorization.person_vehicles.length}}</span>
                    </a>
                    <br>
                    <a v-if="authorization.person_credentials.length > 0 || credential_list.length > 0" href="" class="btn-primary buttons-actions btn m-btn m-btn--icon btn-lg m-btn--icon-only m-btn--pill" data-toggle="modal" data-backdrop="static" data-keyboard="false" data-target="#add_credentials_modal" @click="showModals(index)">
                      <i class="fa fa-address-card"></i>
                      <span class="badge badge-notification">{{authorization.person_credentials.filter((credential) => credential.name !== 'PIN').length}}</span>
                    </a>
                    <label v-if="authorization.person_documents.length > 0">&nbsp;</label>
                    <a v-if="authorization.person_documents.length > 0" href="" class="btn-primary buttons-actions btn m-btn m-btn--icon btn-lg m-btn--icon-only m-btn--pill" data-toggle="modal" data-backdrop="static" data-keyboard="false" data-target="#add_expiration_modal" @click="showModals(index)">
                      <i class="fa  fa-calendar-times-o"></i>
                      <span class="badge badge-notification">{{authorization.person_documents.length}}</span>
                    </a>
                    <label for="see_acompanion">&emsp;</label><br>
                  </div>
                  <div v-if="hasConfigBiometrics[index]" class="pb-3">
                    <label><b>{{'biometrics' | translate | capitalize}}</b></label>
                  </div>
                  <div v-if="hasConfigBiometrics[index]" class="m-alert m-alert--icon m-alert--outline alert alert-info alert-biometric" role="alert">
                    <div class="m-alert__icon_biometric">
                       <div class="form-group m-form__group row">
                          <div class="col-lg-12 pb-2">
                            <div class="pb-3 color-title-biometric">
                              <label v-if="hasBiometrics[index]"><b>{{'update_enrollment' | translate | capitalize}}</b></label>
                              <label v-else><b>{{'new_enrollment' | translate | capitalize}}</b></label>
                            </div>
                            <!-- <a ref="biocard" :href="url[index]" target="_blank" v-tooltip="messageBiometricsTooltip" class="btn btn-primary btn m-btn m-btn--icon btn-lg m-btn--icon-only m-btn--pill color-icon-biometric" style="border-radius: 3rem;">
                            <i class="fa fa-camera"></i>
                            </a> -->
                            <a ref="biocard" v-tooltip="messageBiometricsTooltip" class="m-portlet__nav-link btn btn-primary btn m-btn m-btn--icon btn-lg m-btn--icon-only m-btn--pill color-icon-biometric" data-toggle="modal" data-backdrop="static" data-keyboard="false" data-target="#biometric_modal" style="border-radius: 3rem;" @click.prevent="saveLink(url[index])">
                              <i class="fa fa-camera"></i>
                            </a>
                          </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group m-form__group row" v-if="authorization.responsible_id != null">
                    <div class="col-lg-12 pb-3">
                      <label><b>{{'visit_information' | translate | capitalize}}</b></label>
                    </div>
                    <template v-if="authorization.company_origin != ''">
                      <div class="col-lg-3 pb-3">
                        <label>{{'company_origin' | translate | capitalize}}</label>
                        <input  type="text" class="form-control m-input" v-model="authorization.company_origin" readonly>
                      </div>
                    </template>
                    <template v-if="authorization.responsible_id != null">
                      <div class="col-lg-3 pb-3">
                        <label>{{'visited_person_first_name' | translate | capitalize}}</label>
                        <input  type="text" class="form-control m-input" :value="`${authorization.responsible.first_name} ${authorization.responsible.last_name}`" readonly>
                      </div>
                      <div class="col-lg-3 pb-3">
                        <label>{{'visited_person_identification_number' | translate | capitalize}}</label>
                        <input  type="text" class="form-control m-input" :value="`${authorization.responsible.identification_types.abbreviation} ${authorization.responsible.identification_number}`" readonly>
                      </div>
                    </template>
                  </div>

                  <div :key="datatables_div" class="form-group m-form__group row">
                    <div v-if="is_visitor[index] == 1" class="col-lg-12 pb-3">
                      <label for="see_acompanion">&emsp;</label><br>
                      <div class="row">
                        <div class="col-lg-9">
                          <label><b>{{'companions_management' | translate | capitalize}}</b></label>
                        </div>
                        <div v-if="!validate_blockade[index] && active_autho[index]" class="col-lg-3 text-right">
                          <a href="#" @blur="focus_modal()" @click.prevent="companionModal(index)" class="btn btn-success m-btn m-btn--icon m-btn--wide" data-toggle="modal" data-backdrop="static" data-keyboard="false" data-target="#add_companion_modal" v-if="!validate_end_date[index] && !validate_start_date[index]">
                            <span>
                              <i class="la la-group"></i>
                              <span>{{ 'add'| translate | capitalize }}</span>
                            </span>
                          </a>
                        </div>
                      </div>
                      <label for="see_acompanion">&emsp;</label><br>
                      <div v-if="companion_quantity[authorization.id] > 0">
                        <s-datatable :config="companion_datatable[authorization.id]">
                          <div v-if="props.row.first_name.length > 0" slot="actions" slot-scope="props">
                            <a v-tooltip="messageCredentialsTooltip" class="m-portlet__nav-link btn m-btn m-btn--icon m-btn--icon-only m-btn--pill btn_info" data-toggle="modal" data-backdrop="static" data-keyboard="false" data-target="#acompanion_credentials_modal" @click="list_companion_credential(props.row.person_id, props.row.company_id)">
                              <i class="fa fa-address-card"></i>
                            </a>
                            <a v-tooltip="messageDeleteTooltip" class="m-portlet__nav-link btn m-btn m-btn--icon m-btn--icon-only m-btn--pill" :class="props.row.state == 1 ? 'btn_delete' : 'btn_success'" @click="deleteAccompanied(index, props.row.id, props.row.state == 1 ? 0 : 1, props.row.person_id, props.row.identification_number, authorization.id, props.row.company_id)">
                              <i class="la la-trash"></i>
                            </a>
                          </div>
                        </s-datatable>
                      </div>
                      <div v-else class="m-alert m-alert--icon m-alert--outline alert alert-info alert-background" role="alert">
                        <div class="m-alert__icon">
                          <i class="la la-exclamation-circle"></i>
                          {{'no_companion_autho_message' | translate | capitalize}}
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-12 pb-5">
                      <div class="pb-3">
                        <label><b>{{'property_moves' | translate | capitalize}}</b></label>
                      </div>
                      <div v-if="moves_quantity[authorization.id] > 0">
                        <div class="row">
                          <div :class="[{'has-danger': errors.has(`start_date`)}, 'col-lg-2 pb-3 element-register']">
                            <label :for="`start_date`">{{'start_date' | translate | capitalize }}</label>
                            <s-date-time-picker :id="`start_date`" :name="'start_date'" v-model="start_date" :options="config.start" :placeholder="'AAAA-MM-DD'" @empty="start_date = $event"></s-date-time-picker>
                            <span v-show="errors.has(`start_date`)" class="m-form__help m--font-danger"> {{errors.first(`start_date`)}} </span>
                          </div>
                          <div :class="[{'has-danger': errors.has(`end_date`)}, 'col-lg-2 pb-3 element-register']">
                            <label :for="`end_date`">{{'end_date' | translate | capitalize }}</label>
                            <s-date-time-picker :id="'end_date'" :name="'end_date'" v-model="end_date" :options="config.end" :placeholder="'AAAA-MM-DD'" @empty="end_date = $event"></s-date-time-picker>
                            <span v-show="errors.has(`end_date`)" class="m-form__help m--font-danger"> {{errors.first(`end_date`)}} </span>
                          </div>
                          <div :class="[{'has-danger': errors.has(`end_date`)}, 'col-lg-2 pb-3 element-register']">
                            <label>{{'select_way' | translate | capitalize}}</label>
                            <select id="way" v-model="way"  class="form-control m_selectpicker">
                              <option value="">{{'select_an_option' | capitalize}}</option>
                              <option :value="option.value" v-for="(option, idx) in search_ways" :key="idx">{{ option.name | translate | capitalize }}</option>
                            </select>
                          </div>
                          <div :class="[{'has-danger': errors.has(`end_date`)}, 'col-lg-2 pb-3 element-register']">
                            <label>{{'cp_mov' | translate | capitalize}}</label>
                            <select :name="id_control_point" :id="id_control_point" v-model="control_points_movs" class=" m_selectpicker form-control" :title="'cp_mov' | translate | capitalize " v-validate="'required'">
                              <option value="">{{'select_an_option' | capitalize}}</option>
                              <option v-for="cp in authorization.access_profile.control_points" :key="cp.id" :value="cp.control_point_id"> {{cp.name}} </option>
                            </select>
                            <span v-show="errors.has(id_control_point)" class="m-form__help m--font-danger"> {{errors.first(id_control_point)}} </span>
                          </div>
                          <div :class="[{'has-danger': errors.has(`end_date`)}, 'col-lg-2 pb-3 element-register']">
                            <label>{{'select_messages' | translate | capitalize}}</label>
                            <select id="way" v-model="message"  class="form-control  m_selectpicker">
                              <option value="">{{'select_an_option' | capitalize}}</option>
                              <option :value="option.message" v-for="(option, idx) in messages" :key="idx">{{ option.message }}</option>
                            </select>
                          </div>

                          <div class="col-lg-1">
                            <label>&nbsp;</label><br>
                            <button class="btn btn-success" id="btn-cancel" @click="initMovement">
                              <i class="la la-search"></i>
                            </button>
                          </div>
                        </div>

                        <s-datatable name="property_moves" :config="moves_datatable[authorization.id]">
                          <div  slot="actions" slot-scope="props">
                            <a :title="messagePicturesTooltip" v-if ="showMovPictures === 'true' " class="m-portlet__nav-link btn m-btn m-btn--icon m-btn--icon-only m-btn--pill btn_info" data-toggle="modal" data-backdrop="static" data-keyboard="false" data-target="#movement_pictures_modal" @click="getMovementImages(props.row.id)">
                              <i class="fa fa-camera"></i>
                            </a>
                          </div>
                        </s-datatable>
                      </div>

                      <div v-else class="m-alert m-alert--icon m-alert--outline alert alert-info alert-background" role="alert">
                        <div class="m-alert__icon">
                          <i class="la la-exclamation-circle"></i>
                          {{'no_movement_autho_message' | translate | capitalize}}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-show="(training_quantity > 0) && validate_covid" :key="training_div" class="col-lg-12 pb-3">
                    <div class="row margen-izquierda">
                      <div class="col-lg-6">
                        <label><b>{{'trainings' | translate | capitalize}}</b></label>
                      </div>
                      <div></div>
                    </div>
                    <div v-if="(training_quantity > 0)  && validate_covid">
                      <s-datatable name="training_list" :config="training_datatable[authorization.id]">
                      </s-datatable>
                    </div>
                    <div v-else class="m-alert m-alert--icon m-alert--outline alert alert-info alert-background" role="alert">
                      <div class="m-alert__icon">
                        <i class="la la-exclamation-circle"></i>
                        {{'no_training_message' | translate | capitalize}}
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div v-else>
              <div v-if="person_info.authorizations_reception.length < 2">
                {{'not_authorized_in_company' | translate | capitalize}}
                {{setHidePersonData()}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <s-modal id="access_profile_modal" :title="'create_access_profile' | translate | capitalize">
      <s-access-profile v-show="!modal_access_day" slot="body" :data="access_profile_view" :create_outside="create_access_days" :create_outside_group="true" :view="create_access_days ? false : true"></s-access-profile>
      <s-access-day v-show="modal_access_day" slot="body" :open_outside="true" :data="access_day_view" :view="create_access_days ? false : true" :create_outside="create_access_days" modal="true"></s-access-day>
    </s-modal>
    <s-modal id="add_companion_modal" :title="'add_companion' | translate | capitalize">
      <s-add-companion ref="com_mod" slot="body" :data="companion"></s-add-companion>
    </s-modal>
    <s-modal id="add_cars_modal" :title="'vehicles' | translate | capitalize" :close_header="true" :size="'modal-sm modal-dialog-centered'">
      <div class="modal-body" slot="body">
        <div v-if="person_info.authorizations_reception.length > 0" class="m-scrollable" data-scrollbar-shown="true" data-scrollable="true" data-max-height="200">
          <div class="form-group m-form__group">
            <div v-for="(car, idx) in  person_info.authorizations_reception[autho_index].person_vehicles" :key="idx" v-if="own_fleet_vehicles.find(v => v.license_plate === car.license_plate) === undefined" class="row">
              <div class="col-lg-9">
                <label :for="`plate`">{{'plate' | translate | capitalize }}</label>
                <input class="form-control m-input" type="text" :id="`plate`" v-model="car.license_plate" :name="`plate`" v-validate="''" placeholder="enter plate" readonly>
              </div>
            </div>
          </div>
        </div>
      </div>
    </s-modal>
    <s-modal v-if="belongs_to_company" id="biometric_modal" :title="'biometrics' | translate | capitalize" :close_header="true" :size="'modal-md modal-dialog-centered'">
      <div class="modal-body" slot="body">
        <div class="m-scrollable" data-scrollbar-shown="true" data-scrollable="true" data-max-height="220">
          <div class="form-group m-form__group">
            <label>{{ 'conditions' | translate | capitalize }}</label>
            <p style="text-align: justify;"> {{ 'text_conditions' | translate | capitalize }}</p>
            <div class="row text-center ">
              <div class="col-md-12">
                <a :href="`${url_biometric}`" target="_blank" class="btn btn-primary" @click="close()">Aceptar</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </s-modal>
    <s-modal id="add_ownfleet_cars_modal" :title="'own_fleet_vehicles' | translate | capitalize" :close_header="true" :size="'modal-sm modal-dialog-centered'">
      <div class="modal-body" slot="body">
        <div v-if="person_info.authorizations_reception.length > 0" class="m-scrollable" data-scrollbar-shown="true" data-scrollable="true" data-max-height="200">
          <div class="form-group m-form__group">
            <div v-for="(car, idx) in  person_info.authorizations_reception[autho_index].person_vehicles" :key="idx" v-if="own_fleet_vehicles.find(v => v.license_plate === car.license_plate) !== undefined" class="row">
              <div class="col-lg-9">
                <label :for="`plate`">{{'plate' | translate | capitalize }}</label>
                <input class="form-control m-input" type="text" :id="`plate`" v-model="car.license_plate" :name="`plate`" v-validate="''" placeholder="enter plate" readonly>
              </div>
            </div>
          </div>
        </div>
      </div>
    </s-modal>
    <s-modal v-if="belongs_to_company" id="add_credentials_modal" :title="'credentials' | translate | capitalize" :close_header="true" :size="'modal-sm modal-dialog-centered'">
      <div class="modal-body" slot="body">
        <div class="m-scrollable" data-scrollbar-shown="true" data-scrollable="true" data-max-height="220">
          <div class="form-group m-form__group">
            <div v-for="(auto_credential, idx) in person_info.authorizations_reception[autho_index].person_credentials" :key="idx" class="row card-container" style="margin-bottom: 25px;" v-if="auto_credential.name !== 'PIN'">
              <div class="col-lg-9">
                <div :class="[{'has-danger': errors.has(`credential_${autho_index}_${idx}`)}, 'space-row-container']">
                  <label :for="`credential_${autho_index}_${idx}`">{{ 'credential' | translate | capitalize }}</label>
                  <select :id="`credential_${autho_index}_${idx}`" v-model="auto_credential.credential_id" :name="`credential_${autho_index}_${idx}`" :class="['form-control', {'error': errors.has(`credential_${autho_index}_${idx}`)}]" :disabled="auto_credential.credential_add ? false : true" >
                    <option value="0">
                      {{ 'select_an_option' | translate | capitalize }}
                    </option>
                    <option v-if="auto_credential.credential_add && c.add_in_reception === 1" v-for="c in credential_list " :value="c.id" :key="c.id">
                      {{ c.description }}
                    </option>
                    <option v-if="!auto_credential.credential_add && c.add_in_reception === 0" v-for="c in credential_list " :value="c.id" :key="c.id">
                      {{ c.description }}
                    </option>
                  </select>
                  <span v-show="errors.has(`credential_${autho_index}_${idx}`)" class="m-form__help m--font-danger"> {{errors.first(`credential_${autho_index}_${idx}`)}} </span>
                </div>
                <div :class="[{'has-danger': errors.has(`value_credential_${autho_index}_${idx}`)}, 'space-down']">
                  <label :for="`value_credential_${autho_index}_${idx}`">{{'value_credential' | translate | capitalize }}</label>
                  <input type="text" :id="`value_credential_${autho_index}_${idx}`" v-model="auto_credential.value" :name="`value_credential_${autho_index}_${idx}`" data-vv-as="credential value" :placeholder="'enter_value_credential' | translate | capitalize" class="form-control m-input space-down" v-validate="'required|numeric|max:15'" :readonly="auto_credential.credential_add ? false : true">
                  <span v-show="errors.has(`value_credential_${autho_index}_${idx}`)" class="m-form__help m--font-danger"> {{errors.first(`value_credential_${autho_index}_${idx}`)}} </span>
                </div>
                <div :class="[{'has-danger': errors.has(`facility_code_${autho_index}_${idx}`)}, 'space-down']">
                  <label :for="`facility_code_${autho_index}_${idx}`">{{ 'facility_code' | translate | capitalize }}</label>
                  <select :id="`facility_code_${autho_index}_${idx}`" v-validate="(require_facility === 'true' && auto_credential.name === 'magnetic') ? 'required' : ''" v-model="auto_credential.facility_code" :name="`facility_code_${autho_index}_${idx}`" :class="['form-control']">
                    <option value="">
                      {{ 'select_an_option' | translate | capitalize }}
                    </option>
                    <option v-for="c in list_facility_code" :value="c.facility_code" :key="c.facility_code" >
                      {{ c.facility_code}}
                    </option>
                  </select>
                  <span v-show="errors.has(`facility_code_${autho_index}_${idx}`)" class="m-form__help m--font-danger"> {{errors.first(`facility_code`)}} </span>
                </div>
              </div>
              <br>
              <div v-show="auto_credential.credential_add ? true : false" class="btn-group group-credentials" role="group" aria-label="First group">
                <a href="" class="btn btn-danger m-btn m-btn--icon btn-sm m-btn--icon-only m-btn--pill" @click.stop.prevent="dropCredential(idx)">
                  <i class="fa fa-trash"></i>
                </a>
                <!-- <a @click.prevent="saveCredential(auto_credential)" href="" class="btn btn-primary m-btn m-btn--icon btn-sm m-btn--icon-only m-btn--pill"> -->
                  <a @click.prevent="uniqueCredential(auto_credential, autho_index, auto_credential.facility_code)" href="" class="btn btn-primary m-btn m-btn--icon btn-sm m-btn--icon-only m-btn--pill">
                  <i class="fa fa-save"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
        <a href="" v-show="credential_list.length > 0" class="btn btn-brand m-btn m-btn--icon btn-sm m-btn--icon-only m-btn--pill" @click.stop.prevent="addCredential">
          <i class="fa fa-plus"></i>
        </a>
      </div>
    </s-modal>
    <s-modal id="add_expiration_modal" :title="'expirations' | translate | capitalize" :close_header="true" :size="'modal-sm modal-dialog-centered'">
      <div class="modal-body" slot="body">
        <div v-if="person_info.authorizations_reception.length > 0" class="m-scrollable" data-scrollbar-shown="true" data-scrollable="true" data-max-height="200">
          <div class="form-group m-form__group">
            <div class="form-group m-form__group row">
              <div class="row doc_expiration" v-for="(docs, k) in person_info.authorizations_reception[autho_index].person_documents" :key="k">
                <div class="col-lg-12" :class="{'has-danger': errors.has(`expires_doc_${autho_index}_${k}`)}">
                  <label :for="`expires_doc_${autho_index}_${k}`">{{ docs.name | translate | capitalize }}</label>
                  <s-date-time-picker v-model="docs.value" @input="docExpiration(docs.id, autho_index, k, $event)" :options="config_expiration" v-validate="docs.required === 1 ? 'required' : ''" :name="`expires_doc_${autho_index}_${k}`" :id="`expires_doc_${autho_index}_${k}`" :placeholder="'DD-MM-YYYY'"></s-date-time-picker>
                  <span v-show="errors.has(`expires_doc_${autho_index}_${k}`)" class="m-form__help m--font-danger"> {{errors.first(`expires_doc_${autho_index}_${k}`)}} </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </s-modal>
    <s-modal id="acompanion_credentials_modal" :title="'acompanion_credentials' | translate | capitalize" :close_header="true" :size="'modal-sm modal-dialog-centered'">
      <div class="modal-body" slot="body">
        <div v-if="companion_credential.length > 0" class="m-scrollable" data-scrollbar-shown="true" data-scrollable="true" data-max-height="220">
          <div class="form-group m-form__group">
            <div v-for="(auto_credential, idx) in companion_credential" :key="idx" class="row card-container" style="margin-bottom: 25px;">
              <div class="col-lg-9">
                <div :class="[{'has-danger': errors.has(`credential_${autho_index}_${idx}`)}, 'space-row-container']">
                  <label :for="`credential_${autho_index}_${idx}`">{{ 'credential' | translate | capitalize }}</label>
                  <select :id="`credential_${autho_index}_${idx}`" v-model="auto_credential.credential_id" :name="`credential_${autho_index}_${idx}`" :class="['form-control', {'error': errors.has(`credential_${autho_index}_${idx}`)}]" disabled>
                    <option v-if="auto_credential.credential_add && c.add_in_reception === 1" v-for="c in credential_list " :value="c.id" :key="c.id">
                      {{ c.name }}
                    </option>
                  </select>
                  <span v-show="errors.has(`credential_${autho_index}_${idx}`)" class="m-form__help m--font-danger"> {{errors.first(`credential_${autho_index}_${idx}`)}} </span>
                </div>
                <div :class="[{'has-danger': errors.has(`value_credential_${autho_index}_${idx}`)}, 'space-down']">
                  <label :for="`value_credential_${autho_index}_${idx}`">{{'value_credential' | translate | capitalize }}</label>
                  <input type="text" :id="`value_credential_${autho_index}_${idx}`" v-model="auto_credential.value" :name="`value_credential_${autho_index}_${idx}`" data-vv-as="credential value" :placeholder="'enter_value_credential' | translate | capitalize" class="form-control m-input space-down" readonly>
                  <span v-show="errors.has(`value_credential_${autho_index}_${idx}`)" class="m-form__help m--font-danger"> {{errors.first(`value_credential_${autho_index}_${idx}`)}} </span>
                </div>
              </div>
              <br>
            </div>
          </div>
        </div>
      </div>
    </s-modal>
    <s-modal id="movement_pictures_modal" :title="'movement_pictures' | translate | capitalize" :close_header="true" :size="'modal-lg modal-dialog-centered'">
      <div class="modal-body" slot="body">
        <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel" v-if="movsImages.length > 0">
          <ol class="carousel-indicators">
              <li data-target="#carouselExampleIndicators" v-for="(img, indexLi) of movsImages" :data-slide-to="indexLi" :class="{ active: indexLi==0 }"></li>
          </ol>
          <div class="carousel-inner">
              <div class="carousel-item" v-for="(img, index) of movsImages" :key="index" :class="{ active: index==0 }">
                <img class="d-block w-100" :src="img" alt="First slide">
              </div>
          </div>
          <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="sr-only">Previous</span>
          </a>
          <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
          </a>
        </div>
        <div class="alert alert-primary" role="alert" v-else>
          	{{'empty_mov_images' | translate | titleize}}
        </div>
      </div>
    </s-modal>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { Validator } from 'vee-validate'
import SModal from '@/components/layout/modal/Modal.vue'
import SAccessDay from '@/components/admin/access_day/New.vue'
import SAccessProfile from '@/components/admin/access_profiles/New.vue'
import SDatatable from '@/components/layout/datatable/Datatable.vue'
import SAddCompanion from '@/components/reception/Companion.vue'
import service from '@/services/superaccess'
export default {
  components: { SDatatable, SModal, SAccessDay, SAccessProfile, SAddCompanion },
  data () {
    return {
      refreshCount: 0,
      url_biometric: '',
      datatable: {},
      data_search: [],
      search_value: '',
      search_value_facility: '',
      person_info: { authorizations_reception: [ {person_credentials: []} ] },
      search_type: 0,
      credential_type: '',
      people: [],
      searched: false,
      create_autho: false,
      autho_index: 0,
      preautorization: 0,
      show_datatable: false,
      create_access_days: false,
      access_profile_view: {},
      access_day_view: {},
      identification_type_list: [],
      list_facility_code: [],
      credential_list: [],
      authorization_type_id: 0,
      validate_access_day: [],
      time_property: '',
      documents_validated: [],
      moves_datatable: [],
      moves_quantity: [],
      companion_datatable: [],
      companion_quantity: [],
      training_datatable: [],
      companion: {},
      new_accompanied: [],
      validate_training: [],
      companion_credential: {},
      authorizations_id: [],
      today: '',
      days: [],
      day_name: '',
      validate_end_date: [],
      validate_start_date: [],
      validate_blockade: [],
      validate_novelty: [],
      validate_preauthorization: false,
      person_blocked: false,
      blockade_type: [],
      novelty_type: [],
      move_record: false,
      showMovPictures: false,
      prop_training: false,
      last_move_way: '',
      text_button: 'Registrar',
      active_autho: [],
      singular: false,
      datatables_div: 0,
      is_visitor: [],
      autho_access_days: [],
      autho_control_points: [],
      belongs_to_company: false,
      validate_covid: false,
      start_date: '',
      end_date: '',
      way: '',
      current_companion: '',
      training_quantity: 0,
      company_types: [],
      admin_company: '',
      companies_list: [],
      current_company_type: '',
      hasBiometrics: [],
      hasConfigBiometrics: [],
      url: [],
      hide_person_data: false,
      config: {
        start: {
          format: 'yyyy-mm-dd',
          minView: 2,
          startDate: '',
          autoclose: true,
          pickerPosition: 'bottom-left'
        },
        end: {
          format: 'yyyy-mm-dd',
          minView: 2,
          startDate: '',
          autoclose: true,
          pickerPosition: 'bottom-left'
        }
      },
      config_expiration: {
        format: 'yyyy-mm-dd',
        minView: 2,
        startDate: moment().format('YYYY-MM-DD'),
        autoclose: true,
        pickerPosition: 'bottom-left'
      },
      search_options: [
        { value: 0, name: 'by_identification' },
        { value: 1, name: 'by_name' },
        { value: 2, name: 'by_plate' },
        { value: 3, name: 'by_credential' }
      ],
      search_ways: [
        { value: 2, name: 'by_out' },
        { value: 1, name: 'by_in' }
      ],
      movsImages: [],
      control_points_movs: '',
      messages: [],
      message: '',
      own_fleet_vehicles: [],
      messageDeleteTooltip: this.$options.filters.capitalize('delete_record'),
      messageCredentialsTooltip: this.$options.filters.capitalize('view_credentials'),
      messageDetailTooltip: this.$options.filters.capitalize('view_detail'),
      messagePicturesTooltip: this.$options.filters.capitalize('view_pictures_mov'),
      allow_create_authorizations: true
    }
  },
  computed: {
    ...mapGetters({ modal_access_day: 'getModalAccessDay', permissions: 'getUserPermissions', shard: 'getUserShard' }),
    dataSearch () {
      return this.data_search
    }
  },
  methods: {
    ...mapActions(['searhPersonReception', 'showPersonReception', 'retrieveDetailsReception', 'createNovelty', 'changeNovelty', 'createReception', 'changeReception', 'setStatusAccessProfileModal', 'setStatusEditAccessDay', 'setModalStatusReception', 'showPersonCredential', 'retrieveDataAccessDay', 'countAuthoDatatable', 'countMoveDatatable', 'retrieveMovementConfig', 'recordMovement', 'retrieveLastMovement', 'retriveCompanyTypes', 'retriveCompany', 'getMoveImages', 'isCondominium', 'checkPersonBiometrics', 'showFacilityCode', 'checkPersonTrainings', 'checkPersonDeclaration', 'isTraining', 'countTrainingDatatable', 'CompanyAuthorizationCount']),
    disable: function () {
      document.onkeydown = function (e) {
        return false
      }
      this.searchPerson()
    },
    enable: function () {
      document.onkeydown = function (e) {
        return true
      }
    },
    close () {
      window.$('#biometric_modal').modal('hide')
    },
    saveLink (link) {
      this.url_biometric = link
    },
    getMovementImages (movement_id) {
      this.movsImages = []
      this.$spinner.show()
      this.getMoveImages(movement_id)
        .then((res) => {
          this.movsImages = res.data.paths
          this.$spinner.remove()
        }).catch((err) => {
          this.$spinner.remove()
          console.log(err)
        })
    },
    focus_id: function () {
      this.$refs.id_num.focus()
    },
    validPermission (code) {
      return this.permissions.find(p => { return (p.code === code) }) !== undefined
    },
    goToAuthorization () {
      this.$router.push({ name: 'createStaff', params: { document: this.search_type === 0 ? this.search_value : '' } })
    },
    infoModal (access_profile) {
      this.access_profile_view = access_profile
      this.access_day_view = access_profile.access_day
      this.create_access_days = false
      this.setStatusAccessProfileModal(true)
      this.setStatusEditAccessDay(true)
    },
    showModals (idx) {
      this.autho_index = idx
    },
    addCar () {
      this.person_info.authorizations_reception[this.autho_index].person_vehicles.push({ license_plate: '', new: true })
    },
    addCredential () {
      const person_credential = this.person_info.authorizations_reception[this.autho_index].person_credentials.filter(credential => credential.credential_add === true)
      const credential = this.credential_list.filter(credential => credential.add_in_reception === 1)
      if (person_credential.length < 10) {
        this.person_info.authorizations_reception[this.autho_index].person_credentials.push({ credential_id: 0, value: '', facility_code: 0, credential_add: true })
      } else {
        this.$toast('El maximo de credenciales ya fue alcanzado', 3)
      }
    },
    saveCredential (credential) {
      if (credential.value !== '' && credential.credential_id !== 0) {
        this.$spinner.show()
        let data = {
          object: {
            person_id: this.person_info.id,
            credential_id: credential.credential_id,
            value: credential.value,
            facility_code: credential.facility_code,
            company_id: this.person_info.authorizations_reception[this.autho_index].company_id,
            authori_id: this.person_info.authorizations_reception[this.autho_index].id
          }
        }
        this.createReception(data)
          .then((res) => {
            this.$spinner.remove()
            const idx_credential = this.person_info.authorizations_reception[this.autho_index].person_credentials.findIndex(credential => credential.value === res.data.object.value && credential.credential_id === res.data.object.credential_id && credential.facility_code === res.data.object.facility_code)
            if (idx_credential !== -1) {
              this.person_info.authorizations_reception[this.autho_index].person_credentials[idx_credential] = res.data.object
              this.person_info.authorizations_reception[this.autho_index].person_credentials[idx_credential]['credential_add'] = true
            }
            window.$('#add_credentials_modal').modal('hide')
            this.$toast('success_create_credential', 1)
          })
          .catch((err) => {
            this.$spinner.remove()
            const error = Object.assign({}, err)
            if (error.response.status === 422) {
              this.$toast('credential_already_assigned', 3)
            } else {
              this.$toast('error_create_credential', 4)
            }
            console.log(err)
          })
      } else {
        this.$toast('must_fill_credential', 4)
      }
    },
    dropCredential (idx) {
      if (Object.keys(this.person_info.authorizations_reception[this.autho_index].person_credentials[idx]).length > 3) {
        this.$confirmation('question_inactive_credential', 'sure_inactive_credential')
          .then((res) => {
            if (res.value) {
              this.$spinner.show()
              let data = {
                person_id: this.person_info.id,
                id: this.person_info.authorizations_reception[this.autho_index].person_credentials[idx].id,
                credential_id: this.person_info.authorizations_reception[this.autho_index].person_credentials[idx].credential_id,
                company_id: this.person_info.authorizations_reception[this.autho_index].company_id
              }
              this.changeReception(data)
                .then((res) => {
                  this.$spinner.remove()
                  if (res.status === 200) {
                    this.$toast('success_delete_credential', 1)
                  }
                })
                .catch((err) => {
                  this.$spinner.remove()
                  this.$toast('error_delete_credential', 4)
                  console.log(err)
                })
              this.person_info.authorizations_reception[this.autho_index].person_credentials.splice(idx, 1)
            }
          })
      } else {
        this.person_info.authorizations_reception[this.autho_index].person_credentials.splice(idx, 1)
      }
    },
    goElement (id_element) {
      let pageElement = document.getElementById(id_element)
      let positionX = 0
      let positionY = 0
      while (pageElement != null) {
        positionX += pageElement.offsetLeft
        positionY += pageElement.offsetTop
        pageElement = pageElement.offsetParent
        window.scrollTo(positionX, positionY - document.getElementById('navbar_element_id').offsetHeight)
      }
    },
    cancelNewElement (array, index) {
      this.$delete(array, index)
    },
    newVehicle (index) {
      this.person_info.novelties[index].new_vehicle = {license_plate: ''}
    },
    newCredential (index) {
      for (let i = 0; i < this.credential_list.length; i++) {
        let cond = true
        for (let j = 0; j < this.person_info.novelties[index].person_credentials.length && cond; j++) {
          if (this.credential_list[i].id === this.person_info.novelties[index].person_credentials[j].credential_id) {
            cond = false
          }
        }
        if (cond) {
          this.person_info.novelties[index].new_credential = {id: this.credential_list[i].id, value: ''}
          break
        }
      }
      if (this.person_info.novelties[index].new_credential === '') {
        this.$toast('crendtial_add_error', 3)
      }
    },
    newAccompanied (index) {
      let id_type = this.identification_type_list.find(type => type.abbreviation === 'DNI').id
      this.new_accompanied.push({first_name: this.companion.first_name, last_name: this.companion.last_name, identification_type: id_type, identification_number: this.companion.identification_number, credential_type: this.companion.credential_type, credential_value: this.companion.credential_value, credential_facility_code: this.companion.credential_facility_code})
      let accom_index = this.new_accompanied.length - 1
      this.createAccompanied(index, accom_index)
    },
    createCredential (scope, index) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          this.$spinner.show()
          let data = {
            type: 'credential',
            object: {
              person_id: this.person_info.id,
              credential_id: this.person_info.novelties[index].new_credential.id,
              value: this.person_info.novelties[index].new_credential.value,
              facility_code: this.person_info.novelties[index].new_credential.facility_code,
              company_id: this.person_info.novelties[index].company_id
            }
          }
          this.createReception(data)
            .then((res) => {
              this.$spinner.remove()
              if (res.status === 200) {
                this.person_info.novelties[index].person_credentials.push(res.data.object)
                this.cancelCredential(index)
                this.$toast('success_create_credential', 1)
              }
            })
            .catch((err) => {
              this.$spinner.remove()
              this.$toast('error_create_credential', 4)
              console.log(err)
            })
        }
      })
    },
    list_facility_codes () {
      this.showFacilityCode()
        .then((response) => {
          let company = response.data.company
          let property = response.data.property
          let facility_codes = company.concat(property)
          let result = facility_codes.map(item => {
            return [item.facility_code, item]
          })
          var resultMap = new Map(result)
          this.list_facility_code = [...resultMap.values()]
        })
    },
    createAccompanied (index, index_accompanied) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$spinner.show()
          let access_profile_id = ''
          let local_novelty = this.person_info.authorizations_reception[index]
          let credentials = []
          if (this.new_accompanied[index_accompanied].credential_value !== '') {
            credentials = [{credential_id: this.new_accompanied[index_accompanied].credential_type, value: this.new_accompanied[index_accompanied].credential_value, facility_code: this.new_accompanied[index_accompanied].facility_code}]
          }
          let today_name = this.day_name
          let days = this.days
          let day_values = []
          day_values.push(days.find(day => day.name === today_name).id)
          // let periodicity = ''
          // for (let i = 0; i < local_novelty.access_profile.access_day.length; i++) {
          //   if (local_novelty.access_profile.access_day[i].state !== 0) days_values.push(local_novelty.access_profile.access_day[i].day)
          //   periodicity = local_novelty.access_profile.access_day[i].periodicity_type
          // }
          let control_point_values = []
          for (let i = 0; i < local_novelty.access_profile.control_points.length; i++) {
            control_point_values[i] = local_novelty.access_profile.control_points[i].control_point_id
          }
          let access_profile_params = {
            authorized_type_id: this.authorization_type_id,
            control_points: control_point_values,
            start_time: local_novelty.access_profile.start_time,
            end_time: local_novelty.access_profile.end_time,
            income_number: local_novelty.access_profile.income_number,
            is_personalized: '1',
            department_id: local_novelty.access_profile.department.id,
            description: '',
            periodicity_type: '1',
            value: day_values
          }
          this.$store.dispatch('saveAccessProfile', {access_profile: access_profile_params})
            .then((res) => {
              if (res.status === 200) {
                access_profile_id = res.data.access_profile.id
                let accompanied_params = {
                  identification_number: this.new_accompanied[index_accompanied].identification_number,
                  first_name: this.new_accompanied[index_accompanied].first_name,
                  last_name: this.new_accompanied[index_accompanied].last_name,
                  start_date: this.today,
                  end_date: this.today,
                  identification_type: this.new_accompanied[index_accompanied].identification_type,
                  subgroup: local_novelty.subgroup,
                  observations: '',
                  company_origin: local_novelty.company_origin,
                  email: '',
                  app_movil: false,
                  is_visited: false,
                  is_operator: false,
                  own_fleet: false,
                  profile_operator: '',
                  telephone: '',
                  location: '',
                  position: '',
                  visited_to: local_novelty.visited_id ? local_novelty.visited_id : '',
                  clear_select: false,
                  authorized_credentials: credentials,
                  doc_auth_types: [],
                  own_cars: [],
                  authorization_id: local_novelty.id,
                  access_profile_id: access_profile_id,
                  cargo_cars: {vehicle_type_id: ''},
                  company_id: local_novelty.company_id
                }
                this.createNovelty(accompanied_params)
                  .then((res) => {
                    if (res.status === 200) {
                      this.$spinner.remove()
                      this.person_info.authorizations_reception[index].accompanied.push(res.data.person)
                      this.cancelNewElement(this.new_accompanied, index_accompanied)
                      this.$toast('success_create_accompanied', 1)
                      this.initCompanion()
                    }
                  })
                  .catch((err) => {
                    this.$spinner.remove()
                    this.$toast('error_create_accompanied', 4)
                    console.log(err)
                  })
              }
            })
            .catch((err) => {
              this.$spinner.remove()
              this.$toast('error_create_accompanied', 4)
              console.log(err)
            })
        }
      })
    },
    createVehicle (index) {
      this.$spinner.show()
      let data = {
        type: 'vehicle',
        object: {
          person_id: this.person_info.id,
          vehicles: [{license_plate: this.person_info.authorizations_reception[this.autho_index].person_vehicles[index].license_plate}],
          company_id: this.person_info.authorizations_reception[this.autho_index].company_id
        }
      }
      this.createReception(data)
        .then((res) => {
          this.$spinner.remove()
          this.$toast('success_create_vehicle', 1)
          this.person_info.authorizations_reception[this.autho_index].person_vehicles[index].new = false
          this.person_info.authorizations_reception[this.autho_index].person_vehicles[index] = res.data.object
        })
        .catch((err) => {
          this.$spinner.remove()
          this.$toast('error_create_vehicle', 4)
          console.log(err)
        })
    },
    cancelSearch () {
      this.search_value = ''
      this.search_value_facility = ''
      this.credential_type = ''
      this.search_type = 0
      this.data_search = []
      this.datatable.clean = true
      this.show_datatable = false
      this.searched = false
      setTimeout(() => {
        this.$validator.errors.clear('searh_form')
      }, 50)
      this.focus_id()
    },
    checkAuthoBiometrics () {
      this.person_info.authorizations_reception.forEach((value, key) => {
        let person_bio = {
          biometric: value.biometric,
          email: value.person.email,
          person_dni: value.person.identification_number,
          last_name: value.person.last_name,
          first_name: value.person.first_name
        }
        this.checkPersonBiometrics(person_bio)
          .then((res) => {
            this.hasBiometrics[key] = res.data.result
            this.url[key] = res.data.url
            this.hasConfigBiometrics[key] = res.data.config
            this.bio_button_flag = true
          })
          .catch((err) => {
            console.log(err)
          })
      })
    },
    searchPerson () {
      this.enable()
      this.$validator.validateAll('searh_form').then((result) => {
        if (result) {
          this.datatable.update = true
          this.datatable.query = { search_type: this.search_type, search_value: this.search_value, search_facility: this.search_value_facility, search_credential: this.credential_type }
        }
      })
    },
    validateTrainings (authorizations, person_id) {
      var count = 0
      authorizations.forEach(autho => {
        let data = {
          is_declaration: false,
          authorized_type: autho.access_profile.authorized_type.id,
          department: autho.access_profile.department.id,
          person_id: person_id
        }
        this.checkPersonTrainings(data)
          .then((res) => {
            if (res.status === 200) {
              count = res.data.count
              this.validate_training.push(count)
              if (count > 0 && this.prop_training === 'true') {
                this.move_record = false
                this.refreshDiv()
              }
              this.refreshDiv()
            }
          })
          .catch((err) => {
            console.log(err)
          })
      })
    },
    validateDeclarations (person_id) {
      let data = {
        person_id: person_id
      }
      this.checkPersonDeclaration(data)
        .then((res) => {
          if (res.status === 200) {
            if (res.data.covid_validate === 'true') {
              this.validate_covid = true
              this.refreshDiv()
            }
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    validateTraining () {
      this.isTraining()
        .then((res) => {
          if (res.status === 200) {
            if (res.data.prop_value) {
              this.prop_training = res.data.prop_value
              this.refreshDiv()
            }
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    showPerson (id, novelties) {
      this.$spinner.show()
      this.searched = false
      this.active_autho = true
      this.validate_training = []
      this.validate_covid = false
      let person_info = {
        id: id,
        profile_id: this.shard.profile_id,
        company_id: this.shard.company_id
      }
      this.showPersonReception(person_info)
        .then((res) => {
          this.$spinner.remove()
          if (res.status === 200) {
            this.list_facility_codes()
            this.searched = true
            this.person_info = res.data.person_info
            this.own_fleet_vehicles = res.data.own_fleet_vehicles
            this.belongs_to_company = this.person_info.authorizations_reception.length > 0
            if (this.belongs_to_company) {
              this.today = res.data.person_info.date_property
              this.day_name = res.data.person_info.day_name
              this.checkAuthoBiometrics()
              this.validateDay(res.data.person_info.day_property, res.data.person_info.authorizations_reception)
              this.validateEndDate(this.today, res.data.person_info.authorizations_reception)
              this.validateStartDate(this.today, res.data.person_info.authorizations_reception)
              this.validateBlockade(this.today, res.data.person_info.person_novelty)
              this.validateNovelty(this.today, res.data.person_info.authorizations_reception)
              this.validateTrainings(res.data.person_info.authorizations_reception, person_info.id)
              this.validateDeclarations(person_info.id)
              this.validateVisitorProfile(res.data.person_info.authorizations_reception)
              this.initMovement()
              this.initCompanion()
              this.checkLastMovement()
              this.initTraining()
              this.listAccessDays(res.data.person_info.authorizations_reception)
              this.listControlPoints(res.data.person_info.authorizations_reception)
              this.time_property = this.person_info.time_property
              this.active_autho = new Array(res.data.person_info.authorizations_reception.length)
              this.active_autho.fill(true)
              this.parseDateTime(this.person_info.authorizations_reception)
              this.preautorization = this.person_info.authorizations_reception[this.autho_index].preauthorization
              if (this.preautorization === 2 || this.preautorization === 3) {
                this.move_record = false
                this.validate_preauthorization = false
                this.refreshDiv()
                // let btn_move = document.getElementById('btn-move')
                // btn_move.disabled = true
                // let m_button = this.$refs.move_button
                // m_button.setAttribute('disabled', true)
              } else {
                this.refreshDiv()
                this.validate_preauthorization = true
              }
              if (this.person_info.authorizations_reception[this.autho_index].person_documents.length > 0) this.validatePersonDocuments(this.person_info.authorizations_reception[this.autho_index].person_documents, this.person_info.date_property)
              this.person_info.authorizations_reception[this.autho_index].person_credentials.forEach((value, key) => {
                const credential = this.credential_list.find(credential => credential.id === value.credential_id && credential.add_in_reception === 1)
                if (credential) {
                  this.person_info.authorizations_reception[this.autho_index].person_credentials[key]['credential_add'] = true
                } else {
                  this.person_info.authorizations_reception[this.autho_index].person_credentials[key]['credential_add'] = false
                }
              })
              if (this.person_info.authorizations_reception[this.autho_index].access_profile.is_personalized === 1) this.person_info.authorizations_reception[this.autho_index].access_profile.name = this.$options.filters.capitalize('personalized')
              this.singular = true
              this.$nextTick(function () {
                this.$refs.info_div.scrollIntoView()
              })
            } else {
              this.create_autho = true
              this.$spinner.remove()
              this.$toast('not_authorized_in_company', 3)
            }
          }
        })
        .catch((err) => {
          this.$spinner.remove()
          this.$toast('error_show_person', 4)
          console.log(err)
        })
    },
    parseDateTime (authorizations) {
      authorizations.forEach(auth => {
        auth.create_time = auth.create_time.replace('T', ' ')
        auth.create_time = auth.create_time.substring(0, auth.create_time.indexOf('.'))

        auth.update_time = auth.update_time.replace('T', ' ')
        auth.update_time = auth.update_time.substring(0, auth.update_time.indexOf('.'))
      })
    },
    validatePersonDocuments (person_documents, date_property) {
      this.documents_validated = []
      person_documents.forEach(element => {
        if (Date.parse(element.value) < Date.parse(date_property)) {
          this.documents_validated.push({ name: element.name, value: element.value })
        }
      })
      return this.documents_validated
    },
    refreshDiv: function () {
      this.refreshCount++
    },
    validateDay (id_day, authorizations) {
      this.validate_access_day = []
      authorizations.forEach(element => {
        let idx = element.access_profile.access_day.findIndex(access_day => access_day.day === id_day && access_day.state === 1) === -1
        this.validate_access_day.push(idx)
      })
    },
    validateEndDate (today, authorizations) {
      this.validate_end_date = []
      authorizations.forEach(element => {
        let invalid_authorization = ''
        if (today <= element.end_date || element.end_date === '') {
          invalid_authorization = false
          this.create_autho = false
        } else {
          this.create_autho = true
          invalid_authorization = true
        }
        this.validate_end_date.push(invalid_authorization)
      })
    },
    validateStartDate (today, authorizations) {
      this.validate_start_date = []
      authorizations.forEach(element => {
        let invalid_authorization = ''
        if (today >= element.start_date || element.start_date === '') {
          invalid_authorization = false
          this.create_autho = false
        } else {
          this.create_autho = true
          invalid_authorization = true
        }
        this.validate_start_date.push(invalid_authorization)
      })
    },
    validateBlockade (today, novelties) {
      let blocked = false
      this.blockade_type = []
      this.validate_blockade = []
      novelties.forEach(element => {
        let novelty = element.novelty_types
        if (novelty.blocking_novelty === 1) {
          if (today <= element.end_date || element.end_date === '') {
            blocked = true
          }
          this.blockade_type.push(novelty.name)
        }
      })
      this.validate_blockade.push(blocked)
      this.person_blocked = blocked
      return blocked
    },
    validateNovelty (today, authorizations) {
      let autho_novelty = false
      this.validate_novelty = []
      this.novelty_type = []
      authorizations.forEach(autho => {
        let novelties = []
        novelties = autho.authorization_novelty
        let autho_novelty_type = []
        novelties.forEach(element => {
          let novelty = element.novelty_types
          if (novelty.blocking_novelty !== 1) {
            if (today >= element.start_date && (today <= element.end_date || element.end_date === '')) {
              autho_novelty = true
              let novelty_data = { name: novelty.name, hierarchy: novelty.hierarchy, is_access: novelty.allow_access }
              autho_novelty_type.push(novelty_data)
            }
          }
        })
        autho_novelty_type.sort(function (a, b) {
          if (a.hierarchy > b.hierarchy) {
            return 1
          }
          if (a.hierarchy < b.hierarchy) {
            return -1
          }
          return 0
        })
        this.novelty_type.push(autho_novelty_type[0])
        this.validate_novelty.push(autho_novelty)
      })
    },
    validateVisitorProfile (authorizations) {
      this.is_visitor = []
      authorizations.forEach(element => {
        this.is_visitor.push(element.access_profile.authorized_type.is_visitor)
      })
    },
    refreshSelector (id) {
      window.$(`#${id}`).selectpicker('refresh')
      setTimeout(() => {
        window.$(`#${id}`).selectpicker('refresh')
      }, 100)
      return ''
    },
    ifExistControlPoint (id, index) {
      let final = true
      this.person_info.novelties[index].person_control_points.forEach(element => {
        if (element.control_point_id === id) {
          final = false
        }
      })
      return final
    },
    ifExistCredential (id, index) {
      let final = true
      this.person_info.novelties[index].person_credentials.forEach(element => {
        if (element.credential_id === id) {
          final = false
        }
      })
      return final
    },
    deleteAccompanied (index, authorization_id, state, person_id, identification_number, accompanied_id, company_id) {
      this.$spinner.show()
      let accompanied_index = this.person_info.authorizations_reception[index].accompanied.findIndex(auth => auth.id === authorization_id)
      this.changeNovelty({authorization_id, state, person_id, identification_number, company_id})
        .then((res) => {
          this.initCompanion()
          this.$spinner.remove()
          if (res.status === 200) {
            this.$delete(this.person_info.authorizations_reception[index].accompanied, accompanied_index)
            this.$toast('success_delete_accompanied', 1)
          }
        })
        .catch((err) => {
          this.$spinner.remove()
          this.$toast('error_delete_accompanied', 4)
          console.log(err)
        })
    },
    deleteVehicle (index) {
      this.$spinner.show()
      let data = {
        type: 'vehicle',
        vehicle_id: this.person_info.authorizations_reception[this.autho_index].person_vehicles[index].id
      }
      this.changeReception(data)
        .then((res) => {
          this.$spinner.remove()
          if (res.status === 200) {
            this.person_info.authorizations_reception[this.autho_index].person_vehicles.splice(index, 1)
            this.$toast('success_delete_vehicle', 1)
          }
        })
        .catch((err) => {
          this.$spinner.remove()
          this.$toast('error_delete_vehicle', 4)
          console.log(err)
        })
    },
    uniqueLicensePlate () {
      const uniqueLicensePlate = (obj, args) => {
        let result = true
        for (let i = 0; i < this.person_info.novelties[args[0]].person_vehicles.length; i++) {
          if (this.person_info.novelties[args[0]].person_vehicles[i].license_plate.toUpperCase() === obj.toUpperCase()) {
            result = false
            break
          }
        }
        return {
          valid: result,
          data: {
            message: this.$options.filters.capitalize(this.$options.filters.translate('vehicle_exist_validate'))
          }
        }
      }
      Validator.extend('uniqueLicensePlate', {
        validate: uniqueLicensePlate,
        getMessage: (field, params, data) => {
          return data.message
        }
      })
    },
    searchByName () {
      const searchByName = (obj, args) => {
        let result = true
        let words = this.search_value.split(' ')
        if (words.length < 2 || words[1] === '' || words[1].length < 3) result = false
        return {
          valid: result,
          data: {
            message: this.$options.filters.capitalize(this.$options.filters.translate('least_two_words'))
          }
        }
      }
      Validator.extend('search_name', {
        validate: searchByName,
        getMessage: (field, params, data) => {
          return data.message
        }
      })
    },
    hourToSeconds (hour) {
      let seconds = hour.split(':')
      return (+seconds[0]) * 60 * 60 + (+seconds[1]) * 60
    },
    initTraining () {
      const self = this
      for (let i = 0; i < this.person_info.authorizations_reception.length; i++) {
        var auth_id = this.person_info.authorizations_reception[i].id
        var auth_type_id = this.person_info.authorizations_reception[i].access_profile.authorized_type.id
        var depa_id = this.person_info.authorizations_reception[i].access_profile.department.id
        let obj_training = {
          url: '/api/training/training_person',
          method: 'post',
          size: 15,
          columns: [
            {
              field: 'title',
              title: 'title',
              template (row) {
                return `${row.title}`
              }
            },
            {
              field: 'approved',
              title: 'state',
              template (row) {
                let output = ''
                let approvedStatus = row.approved === null ? 0 : row.approved
                switch (approvedStatus) {
                  case false:
                    output = self.$options.filters.capitalize('not_approved')
                    break
                  case true:
                    output = self.$options.filters.capitalize('approved')
                    break
                  case 0:
                    output = self.$options.filters.capitalize('pending')
                    break
                }
                return output
              }
            },
            {
              field: 'creation_date',
              title: 'realization_date',
              template (row) {
                if (row.realization_date) {
                  return row.realization_date.split('T')[0]
                } else {
                  return '-'
                }
              }
            },
            {
              field: 'expiration_date',
              title: 'expiration_date',
              template (row) {
                if (row.expiration_date !== null) {
                  return row.expiration_date
                } else {
                  return '-'
                }
              }
            }],
          actions: false,
          update: false,
          query: { person: this.person_info.id, is_declaration: false, authorized_type: auth_type_id, department: depa_id }
        }
        this.training_datatable[auth_id] = obj_training
        this.training_datatable[auth_id].update
        let count_data = {is_declaration: false, authorized_type: auth_type_id, department: depa_id}
        this.countTrainingRecords(count_data)
      }
    },
    initMovement () {
      for (let i = 0; i < this.person_info.authorizations_reception.length; i++) {
        var auth_id = this.person_info.authorizations_reception[i].id
        const self = this
        let obj_movement = {
          url: '/api/movement',
          method: 'post',
          size: 15,
          columns: [
            {
              field: 'way',
              title: 'sense',
              template (row) {
                return row.way === 1 ? self.$options.filters.capitalize('in') : self.$options.filters.capitalize('out')
              }
            },
            {
              field: 'create_time',
              title: 'date_time',
              template (row) {
                return row.create_time.replace('T', ' ').substring(0, row.create_time.indexOf('.'))
              }
            },
            {
              field: 'message',
              title: 'description',
              template (row) {
                if (row.movement_type === 2) {
                  return self.$options.filters.capitalize('incomplete')
                } else {
                  return self.$options.filters.capitalize(row.message.toLowerCase())
                }
              }
            },
            {
              field: 'name',
              title: 'control_points',
              template (row) {
                return row.name
              }
            }],
          actions: true,
          update: false,
          clean: false,
          query: { search_type: this.search_type, search_value: this.person_info.id, auth_id: auth_id, start_date: this.start_date, end_date: this.end_date, way: this.way, control_point: this.control_points_movs, message: this.message }
        }
        this.moves_datatable[auth_id] = obj_movement
        this.moves_datatable[auth_id].update
        this.countMovementRecords(auth_id)
      }
    },
    initCompanion () {
      for (let i = 0; i < this.person_info.authorizations_reception.length; i++) {
        var auth_id = this.person_info.authorizations_reception[i].id
        var comp_id = this.person_info.authorizations_reception[i].company_id
        let obj_companion = {
          url: '/api/authorization',
          method: 'post',
          size: 15,
          columns: [
            {
              field: 'document',
              title: 'identification_number',
              template (row) {
                return ` ${row.identification_number}`
              }
            },
            {
              field: 'lastname',
              title: 'lastname',
              template (row) {
                return `${row.last_name}`
              }
            },
            {
              field: 'name',
              title: 'name',
              template (row) {
                return `${row.first_name}`
              }
            }],
          actions: true,
          update: false,
          query: { autho_id: auth_id, company_id: comp_id, person_document: '', date_start: '', date_end: '', is_cargo: '0' }
        }
        this.companion_datatable[auth_id] = obj_companion
        this.companion_datatable[auth_id].update
        this.countCompanionRecords(auth_id)
      }
    },
    companionModal (index) {
      this.autho_index = index
      this.setModalStatusReception(true)
    },
    focus_modal () {
      this.$refs.com_mod.focus_id()
    },
    list_companion_credential (person, company) {
      var data = [person, company]
      this.showPersonCredential(data)
        .then((res) => {
          if (res.status === 200) {
            this.searched = true
            this.companion_credential = res.data.person_credentials
            this.companion_credential.forEach((person_cred, key) => {
              const credential = this.credential_list.find(credential => credential.id === person_cred.credential_id && person_cred.credential.add_in_reception === 1)
              if (credential) {
                this.companion_credential[key]['credential_add'] = true
              } else {
                this.companion_credential[key]['credential_add'] = false
              }
            })
          }
        })
        .catch((err) => {
          this.$toast('error_show_person', 4)
          console.log(err)
        })
    },
    recMovement () {
      let way = ''
      let inter = ''
      this.$refs.move_button.setAttribute('disabled', true)
      if (this.last_move_way === null || this.last_move_way === 2) {
        way = 1
        inter = 1
      } else {
        way = 2
        inter = 2
      }
      let movement_params = {
        prefix: 'PZ',
        type: this.person_info.identification_types.abbreviation,
        value: this.person_info.identification_number,
        name: this.person_info.first_name + ' ' + this.person_info.last_name,
        in_out: way,
        interface_id: inter
      }
      this.$spinner.show()
      this.recordMovement(movement_params)
        .then((res) => {
          if (res.status === 200) {
            if (res.data.message === 'authorized') {
              this.$toast(res.data.message, 1)
            } else {
              this.$toast(res.data.message, 3)
            }
            this.countMovementRecords(res.data.authorization_id)
            this.moves_datatable.update = true
            this.checkLastMovement()
          } else {
            this.$toast('record_move_error', 4)
            this.delay_button()
          }
          this.datatables_div += 1
          this.$spinner.remove()
        })
    },
    checkLastMovement () {
      this.retrieveLastMovement(this.person_info.id)
        .then((res) => {
          if (res.status === 200) {
            this.last_move_way = res.data.way
            if (this.last_move_way === null || this.last_move_way === 2) {
              this.text_button = 'record_in'
            } else {
              this.text_button = 'record_out'
            }
            this.delay_button()
          }
        })
    },
    checkMovementConfig () {
      this.retrieveMovementConfig()
        .then((res) => {
          if (res.status === 200) {
            this.move_record = res.data.move_config
            this.showMovPictures = res.data.show
          }
        })
    },
    delay_button () {
      let m_button = this.$refs.move_button
      setTimeout(function () {
        m_button.removeAttribute('disabled')
      }, 3000)
    },
    change_active_autho_status (index) {
      this.active_autho[index] = false
    },
    show_day_name (id) {
      const day = this.days.find(day => day.id === id)
      return this.$options.filters.capitalize(day.name)
    },
    listAccessDays (autho) {
      this.autho_access_days = []
      let day_name = ''
      autho.forEach((auth, a_key) => {
        day_name = ''
        auth.access_profile.access_day.forEach((a_day, d_key) => {
          day_name = day_name + this.show_day_name(a_day.day) + '\n'
        })
        this.autho_access_days[a_key] = day_name
      })
    },
    listControlPoints (autho) {
      this.autho_control_points = []
      let c_point = ''
      autho.forEach((auth, a_key) => {
        c_point = ''
        auth.access_profile.control_points.forEach((a_cp, d_key) => {
          c_point = c_point + a_cp.name + '\n'
        })
        this.autho_control_points[a_key] = c_point
      })
    },
    countCompanionRecords (auth_id) {
      this.countAuthoDatatable(auth_id)
        .then((res) => {
          this.companion_quantity[auth_id] = res.data.companion_count
          this.datatables_div += 1
        })
        .catch((err) => {
          console.log(err)
        })
    },
    countMovementRecords (auth_id) {
      this.countMoveDatatable(auth_id)
        .then((res) => {
          this.moves_quantity[auth_id] = res.data.movement_count
          this.datatables_div += 1
          this.messages = res.data.message
        })
        .catch((err) => {
          console.log(err)
        })
    },
    countTrainingRecords (count_data) {
      this.countTrainingDatatable(count_data)
        .then((res) => {
          this.training_quantity = res.data.training_count
        })
        .catch((err) => {
          console.log(err)
        })
    },
    startDate (value) {
      this.$set(this.config.end, 'startDate', value)
      if (this.start_date.replace(':', '') > this.end_date.replace(':', '')) {
        this.end_date = this.start_date
      }
    },
    validCompany (autho_company) {
      let card_visible = false
      if (this.current_company_type === this.admin_company || this.shard.company_id === autho_company) {
        card_visible = true
      }
      return card_visible
    },
    setHidePersonData () {
      this.hide_person_data = true
    },
    getIsCayena (shard) {
      this.isCondominium(shard)
        .then((res) => {
          this.is_photo_auth = res.data.is_photo_auth
          this.require_facility = res.data.require_facility
        })
    },
    uniqueCredential (credential, key, facility_code) {
      let value = credential.value
      let credential_id = credential.credential_id
      if (value.length >= 1) {
        service.post('/api/person/check-credential', this.$store, { value: value, credential_id: credential_id, id: '', facility_code: facility_code })
          .then((response) => {
            if (!response.data.valid) {
              swal({
                type: 'question',
                showCancelButton: true,
                html: this.$options.filters.capitalize('credential_already_assigned'),
                cancelButtonText: this.$options.filters.capitalize('no'),
                confirmButtonText: this.$options.filters.capitalize('yes')
              }).then((res) => {
                if (res.value) {
                  this.$validator.validateAll().then((result) => {
                    if (result) {
                      this.saveCredential(credential)
                    }
                  })
                }
              })
            } else {
             this.saveCredential(credential)
              // this.$validator.validateAll().then((result) => {
              //   if (result) {
              //     this.saveCredential(credential)
              //  }
             //} )
            }
          })
      }
    },
    getCompanyAuthorizationCount () {
      this.CompanyAuthorizationCount({})
        .then((res) => {
          if (res.status === 200) {
            this.allow_create_authorizations = res.data.allowed
          }
        })
        .catch((err) => {
          this.$spinner.remove()
          console.log(err)
        })
    }
  },
  mounted () {
    this.$root.$on('add_c_function', (id_number, l_name, f_name, cred_value, cred_type) => {
      this.companion = {
        identification_number: id_number,
        last_name: l_name,
        first_name: f_name,
        credential_type: cred_type,
        credential_value: cred_value
      }
      if (Object.entries(this.companion).toString() !== Object.entries(this.current_companion).toString()) {
        this.current_companion = this.companion
        this.newAccompanied(this.autho_index)
      }
    })
    const datatable = {
      url: '/api/reception/all',
      method: 'POST',
      size: 15,
      columns: [
        {
          field: 'first_name',
          title: 'first_name',
          template: function (row) {
            return `${row.first_name}`
          }
        },
        {
          field: 'last_name',
          title: 'last_name',
          template: function (row) {
            return `${row.last_name}`
          }
        },
        {
          field: 'identification_number',
          title: 'identification_number',
          template: function (row) {
            return `${row.identification_number}`
          }
        },
        {
          field: 'email',
          title: 'email',
          template: function (row) {
            return row.email === null ? 'N/A' : row.email
          }
        }],
      actions: true,
      update: false,
      clean: false,
      query: { search_type: this.search_type, search_value: this.search_value }
    }
    this.datatable = datatable
    this.getIsCayena(this.shard)
  },
  created () {
    this.getCompanyAuthorizationCount()
    this.uniqueLicensePlate()
    this.searchByName()
    this.validateTraining()
    this.retrieveDetailsReception()
      .then((res) => {
        if (res.status === 200) {
          if (res.data.credentials.length === 0) {
            this.credential_list = [{id: '', name: '', facility_code: ''}]
          } else {
            this.credential_list = res.data.credentials
          }
          if (res.data.identification_types.length === 0) {
            this.identification_type_list = [{id: '', name: ''}]
          } else {
            this.identification_type_list = res.data.identification_types
          }
          this.authorization_type_id = res.data.authorized_type.id
        }
      })
      .catch((err) => {
        this.$toast('error_get_data', 4)
        console.log(err)
      })
    this.retrieveDataAccessDay()
      .then((res) => {
        this.days = res.data.days
      })
      .catch((err) => {
        this.$toast('error_load_data_form', 4)
        console.log(err)
      })
    this.checkMovementConfig()
    this.retriveCompanyTypes()
      .then((res) => {
        this.company_types = res.data
        this.admin_company = this.company_types.find(compa => compa.name === 'Administradora de propiedad').id
      })
      .catch((res) => {
        console.log(res)
      })
    this.retriveCompany()
      .then((res) => {
        this.companies_list = res.data
        this.current_company_type = this.companies_list.find(compa => compa.id === this.shard.company_id).company_type_id
      })
      .catch((res) => {
        console.log(res)
      })
  },
  watch: {
    dataSearch (newVal, oldVal) {
      if (this.data_search.length > 0) {
        let blockade = this.validateBlockade(this.today, this.data_search[0].person_novelty)
        let autho = this.data_search[0].authorizations_reception.length
        if (newVal.length === 1) {
          if (!blockade) {
            this.singular = true
          } else {
            if (autho > 0) {
              this.singular = true
            } else {
              this.singular = false
            }
          }
        } else {
          this.singular = false
        }
      } else {
        this.singular = false
      }
      if (this.singular) {
        this.showPerson(this.data_search[0].id, this.data_search[0].person_novelty)
      }
    },
    search_type () {
      this.search_value = ''
    }
  }
}
</script>
<style scoped>
.break-world {
  word-wrap:break-word;
}
.table{
  text-align: center !important;
}
.table th{
  text-align: center !important;
}
.tr{
  text-align: center !important;
}
.button-center-table {
  display:block;
  width:100%;
  text-align:center
}
.doc_expiration {
  margin: 3px !important;
}
.actions {
  text-align: right;
}
.actions > button {
  min-width: 140px;
}
.card-header {
  background-color: #2c375b !important;
}
.card_title {
  color: white !important;
}
.group-credentials {
  padding-top: 30px;
}
.space-row-container {
  padding-bottom: 20px !important;
}
.card-container {
  background: #fff;
  border-radius: 2px;
  margin: 1px;
  position: relative;
  box-shadow: 1px 1px 1px 1px #ccc;
  -webkit-transition: box-shadow 0.3s ease-in-out;
  -moz-transition: box-shadow 0.3s ease-in-out;
  -o-transition: box-shadow 0.3s ease-in-out;
  transition: box-shadow 0.3s ease-in-out;
}
.card-container:hover {
  box-shadow: 3px 3px 2px 3px #ccc;
}
.space-margin-top {
    margin-top: 30px !important;
}
.space-down {
    margin-bottom: 20px !important;
}
.badge-notification {
  border-radius: 60px;
  background-color: #D73925;
}
.alert-background {
  background-color: #e0ebf9 !important;
}
.center-text {
  text-align:center !important;
}
.badge-danger {
  padding: 0.7em !important;
}
.alert-biometric{
  background-color: #e0ebf9 !important;
}
.m-alert__icon_biometric{
    display: table-cell;
    vertical-align: middle;
    text-align: center;
    padding: 2.5rem 0.5rem 1.45rem 2.5rem;
    line-height: 0;
    width: 1%;
    color: white !important;
}
.color-icon-biometric{
  color: white !important;
}
.color-title-biometric{
  color: #0b84e0 !important;
}
</style>



// WEBPACK FOOTER //
// Reception.vue